import { Box, type InputBaseComponentProps, Select } from "@mui/material";
import React, { type ReactNode } from "react";

import { CustomMenuProps } from "..";

interface Props<T> {
  value: Array<T>;
  onChange: (value: Array<T>) => void;
  renderValue: (value: Array<T>) => ReactNode;
  children: ReactNode;
  inputProps?: InputBaseComponentProps;
}

export function MultiSelectFilter<T>({
  value,
  onChange,
  renderValue,
  children,
  inputProps,
}: Props<T>) {
  return (
    <Box sx={{ backgroundColor: "common.white" }}>
      <Select
        fullWidth
        multiple
        displayEmpty
        variant="outlined"
        value={value}
        onChange={(e) => onChange(e.target.value as Array<T>)}
        renderValue={renderValue}
        MenuProps={CustomMenuProps}
        inputProps={inputProps}
      >
        {children}
      </Select>
    </Box>
  );
}
